import * as React from "react";
import type { SVGProps } from "react";
const SvgBottomRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="bottom_right_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M620.245 680.661h-319.36a42.667 42.667 0 1 0 0 85.334H722.86a43.093 43.093 0 0 0 43.093-43.094V300.928a42.667 42.667 0 1 0-85.333 0v319.403L329.13 268.928c-15.616-15.659-41.814-14.805-58.454 1.877-16.64 16.64-17.493 42.838-1.92 58.454L620.203 680.66z"
    />
  </svg>
);
export default SvgBottomRightIcon;
